module.exports = __webpack_public_path__ + "img/info2.1ab1df4a.svg";